module.exports = __webpack_public_path__ + "static/uhc21-product.9501a47f.jpg";